export const sxFullWidthMinus4px = { height: "calc(100% - 4px)" };
